module.exports = __webpack_public_path__ + "static/img/wealth_level_80.1f352b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_80.png
// module id = B3rC
// module chunks = 0